import React, { useState } from "react";
import { HeaderFixed, HeaderHeight, Nav } from "./styles";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { navMotion, linkMotion } from "../../framer/animation";

const Header = ({ theme, setTheme }) => {
	const [navOpen, setNavOpen] = useState(false);

	const themeToggler = () => {
		setTheme(theme === "light" ? "dark" : "light");
	};

	const navToggler = () => {
		setNavOpen(!navOpen);
	};

	return (
		<>
			<HeaderHeight />
			<HeaderFixed>
				<header>
					<div onClick={themeToggler} className='theme-switcher'>
						<div
							className={`switch-button ${theme === "light" ? "" : "clicked"}`}
						></div>
					</div>
					<motion.div className='logo'>
						<Link to='/'>
							<span>A</span>
							<span>S</span>
						</Link>
					</motion.div>
					<div
						className={`burger-menu ${navOpen ? "close" : "false"}`}
						onClick={navToggler}
					>
						<div className='line'></div>
						<div className='line'></div>
						<div className='line'></div>
						<div className='line'></div>
						<div className='line'></div>
					</div>
				</header>
			</HeaderFixed>
			<Nav
				variants={navMotion}
				initial='hidden'
				animate={navOpen ? "show" : "hidden"}
			>
				<motion.div variants={linkMotion} className='switcher-container'>
					<motion.div onClick={themeToggler} className='theme-switcher'>
						<div
							className={`switch-button ${theme === "light" ? "" : "clicked"}`}
						></div>
					</motion.div>
				</motion.div>
				<motion.ul>
					<motion.li variants={linkMotion} whileTap={{ scale: 0.9 }}>
						<Link to='about' onClick={navToggler}>
							About me
						</Link>
					</motion.li>
					<motion.li variants={linkMotion}>
						<Link to='skills' onClick={navToggler}>
							Skills
						</Link>
					</motion.li>
					<motion.li variants={linkMotion}>
						<Link to='contact' onClick={navToggler}>
							Contacts
						</Link>
					</motion.li>
					<motion.li variants={linkMotion}>
						<Link to='projects' onClick={navToggler}>
							Projects
						</Link>
					</motion.li>
					<motion.div variants={linkMotion} className='copyright'>
						<div className='cr-text'>
							<p>
								&copy; 2022. <br /> Designed and created
								<br /> by Amirkhon Shakirov.{" "}
							</p>
						</div>
					</motion.div>
				</motion.ul>
			</Nav>
		</>
	);
};

export default Header;
